import React from "react";
import { useTranslation } from "react-i18next";

// Cabecera de la vista de sección (pantallas 07-10/15): enlace de vuelta + indicador de
// alcance, visible solo dentro de una sección acotada.
const ScopeIndicator = ({ sectionName, onBack }) => {
  const { t } = useTranslation();
  return (
    <div className="bq-scope">
      {/* Mismas clases que "Ver más" (SectionRow.js): es la acción contraria (salir de una
          sección en vez de entrar en ella) en la misma zona de la página, así que debe leerse
          con el mismo peso visual (tamaño, negrita) y no perderse entre el resto de textos. */}
      <button type="button" className="bq-scope-back bq-section-row-more" onClick={onBack}>
        <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
          <polyline points="15 6 9 12 15 18" />
        </svg>
        {t("search.buscar.backToAllSections")}
      </button>
      <span className="bq-scope-indicator" aria-live="polite">
        <span className="bq-scope-dot" aria-hidden="true" />
        {t("search.buscar.scopeIndicator", { section: sectionName })}
      </span>
    </div>
  );
};

export default ScopeIndicator;
